/* SnapCharger theme — global behaviors */
(function () {
  'use strict';

  // FAQ accordion
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (q) q.parentElement.classList.toggle('open');
  });

  // Color pill selector (visual only — variant logic is product-form.js)
  document.querySelectorAll('.color-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      pill.parentElement.querySelectorAll('.color-pill').forEach(function (p) {
        p.classList.remove('active');
      });
      pill.classList.add('active');
    });
  });

  // Sticky bottom bar after scrolling past hero
  var stickyBar = document.getElementById('stickyBar');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      stickyBar.classList.toggle('visible', window.scrollY > 600);
    }, { passive: true });
  }

  // Smooth scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length > 1) {
        var el = document.querySelector(id);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
      }
    });
  });
})();
